import { render, staticRenderFns } from "./intentStatistics.vue?vue&type=template&id=32faac26&scoped=true&"
import script from "./intentStatistics.vue?vue&type=script&lang=js&"
export * from "./intentStatistics.vue?vue&type=script&lang=js&"
import style0 from "./intentStatistics.vue?vue&type=style&index=0&id=32faac26&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32faac26",
  null
  
)

export default component.exports